import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import AddressSearch from "../components/AddressSearch";
import { HomeIcon, PencilIcon, TrashIcon } from "../components/messages/icons";

// "Mes adresses" — miroir de OLTODO/app/my-addresses.tsx : carnet d'adresses privées façon Uber
// Eats, jamais un lieu OLTODO. Écran unique liste + formulaire inline (ressource trop simple pour
// justifier une page de détail séparée).
export default function MyAddresses() {
  const navigate = useNavigate();
  const { lang } = useApp();
  const [addresses, setAddresses] = useState<any[] | null>(null);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [label, setLabel] = useState("");
  const [address, setAddress] = useState("");
  const [coords, setCoords] = useState<{ lat: number | null; lon: number | null }>({ lat: null, lon: null });
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get("/addresses/mine").then(d => setAddresses(d?.addresses || [])).catch(() => setAddresses([]));
  };

  useEffect(load, []);

  const resetForm = () => { setShowForm(false); setEditingId(null); setLabel(""); setAddress(""); setCoords({ lat: null, lon: null }); };

  const startEdit = (a: any) => {
    setEditingId(a.id); setLabel(a.label); setAddress(a.address);
    setCoords({ lat: a.latitude ?? null, lon: a.longitude ?? null });
    setShowForm(true);
  };

  const save = () => {
    if (!label.trim() || !address.trim() || saving) return;
    setSaving(true);
    const body = { label: label.trim(), address: address.trim(), latitude: coords.lat, longitude: coords.lon };
    const req = editingId ? api.put(`/addresses/${editingId}`, body) : api.post("/addresses", body);
    req.then(data => {
      if (data && !data.error) { resetForm(); load(); }
      else alert(data?.error || t(lang, "error_connection"));
    }).catch(() => alert(t(lang, "error_connection"))).finally(() => setSaving(false));
  };

  const remove = (id: string) => {
    if (!window.confirm(t(lang, "my_addresses_delete_confirm_title"))) return;
    api.delete(`/addresses/${id}`).then(data => {
      if (data && !data.error) load();
      else alert(data?.error || t(lang, "error_connection"));
    }).catch(() => alert(t(lang, "error_connection")));
  };

  const label_: React.CSSProperties = { fontSize: 12, fontWeight: 600, color: "#666", display: "block", marginBottom: 8, marginTop: 4 };
  const input: React.CSSProperties = { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1px solid #E0E0E0", fontSize: 14, marginBottom: 14, boxSizing: "border-box" };

  return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <button onClick={() => navigate(-1)} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 20, color: "#666" }}>←</button>
        <span style={{ fontSize: 20, fontWeight: 700, flex: 1 }}>{t(lang, "side_menu_my_addresses")}</span>
        <button onClick={() => (showForm ? resetForm() : setShowForm(true))} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 22, color: "#0a0a0a" }}>{showForm ? "✕" : "+"}</button>
      </div>

      {showForm && (
        <div style={{ border: "1px solid #EEE", borderRadius: 14, padding: 16, marginBottom: 16 }}>
          <label style={label_}>{t(lang, "my_addresses_label_field")}</label>
          <input value={label} onChange={e => setLabel(e.target.value.slice(0, 100))} placeholder={t(lang, "my_addresses_label_placeholder")} style={input} />
          <label style={label_}>{t(lang, "my_addresses_address_field")}</label>
          <div style={{ marginBottom: 14 }}>
            <AddressSearch value={address} onChange={(l, lat, lon) => { setAddress(l); setCoords({ lat, lon }); }} placeholder={t(lang, "bday_location_placeholder")} />
          </div>
          <button onClick={save} disabled={!label.trim() || !address.trim() || saving} style={{ width: "100%", padding: 12, borderRadius: 12, border: "none", backgroundColor: label.trim() && address.trim() ? "#0a0a0a" : "#E0E0E0", color: "white", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
            {editingId ? t(lang, "save") : t(lang, "bday_gift_add_btn")}
          </button>
        </div>
      )}

      {addresses === null ? (
        <div style={{ textAlign: "center", color: "#999", marginTop: 40 }}>{t(lang, "msg_loading")}</div>
      ) : addresses.length === 0 && !showForm ? (
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <div style={{ width: 56, height: 56, borderRadius: 28, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}><HomeIcon size={24} color="#999" /></div>
          <div style={{ fontSize: 13, color: "#999" }}>{t(lang, "my_addresses_empty")}</div>
        </div>
      ) : (
        addresses.map(a => (
          <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 12, border: "1px solid #EEE", borderRadius: 14, padding: 12, marginBottom: 10 }}>
            <div style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><HomeIcon size={19} color="#0a0a0a" /></div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.label}</div>
              <div style={{ fontSize: 12, color: "#999", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.address}</div>
            </div>
            <button onClick={() => startEdit(a)} title={t(lang, "save")} style={{ border: "none", background: "none", cursor: "pointer", color: "#999", display: "flex" }}><PencilIcon size={16} color="#999" /></button>
            <button onClick={() => remove(a.id)} title={t(lang, "msg_delete_action")} style={{ border: "none", background: "none", cursor: "pointer", color: "#999", display: "flex" }}><TrashIcon size={16} color="#999" /></button>
          </div>
        ))
      )}
    </div>
  );
}
